import formatErrorMessage from '@/utils/errorMessages';
import version from '@/utils/version';

export interface NaluriChatErrorOptions {
  message: string;
  code: string;
}

export class NaluriChatError extends Error {
  readonly error: boolean;
  readonly message: string;
  readonly errorCode: string;
  readonly version: string;

  constructor({ message, code }: NaluriChatErrorOptions) {
    const msg = NaluriChatError.makeMessage(message);
    super(msg);
    this.error = true;
    this.errorCode = code || '500';

    Error.captureStackTrace(this, NaluriChatError);
    Object.setPrototypeOf(this, NaluriChatError.prototype);
  }

  private static makeMessage(message?: string) {
    const msg = message
      ? formatErrorMessage(message)
      : 'Unknown error occurred.';

    return `[Naluri Chat SDK] v${version}] Error: ${msg}`;
  }
}

export class NaluriAccountError extends Error {
  public error: boolean;

  public message: string;

  constructor({ message }: { message: string }) {
    super(message);
    this.error = true;

    console.debug('NaluriChatError', message);
    this.message = message || 'Unknown Naluri Chat error.';

    Object.setPrototypeOf(this, NaluriAccountError.prototype);
    Error.captureStackTrace(this, NaluriAccountError);
  }
}

export class NaluriRefreshTokenError extends NaluriAccountError {
  constructor() {
    super({ message: 'Refresh token failed.' });
    Object.setPrototypeOf(this, NaluriRefreshTokenError.prototype);
    Error.captureStackTrace(this, NaluriRefreshTokenError);
  }
}
